import { render, staticRenderFns } from "./CardDeckAssign.vue?vue&type=template&id=4b394169&scoped=true"
import script from "./CardDeckAssign.vue?vue&type=script&lang=js"
export * from "./CardDeckAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b394169",
  null
  
)

export default component.exports